import React from "react";
import { styled } from "goober";

import SingleMenu from "@/app/AppShellSingleMenu.jsx";

const MegaMenuWrapper = styled("div")`
  display: flex;
  flex-direction: row;

  background: var(--shade7);

  border-radius: var(--sp-2);
  border: 1px solid var(--shade3-15);

  box-shadow:
    0px 12px 24px 0px rgba(7, 8, 12, 0.25),
    0px 4px 12px 0px rgba(7, 8, 12, 0.25);

  &:has(li.has-menu:hover) {
    background: var(--shade8);

    .category {
      opacity: 0.25;
    }

    ${
      "" /**
       * Selects the first-level menu links that are not currently active.
       * This dims them while not dimming the currently shown sub-menu.
       */
    }
    .menu-category > * > ul > li:not(:hover) > .link {
      opacity: 0.25;
    }
  }
`;

const MenuColumnWrapper = styled("div")`
  display: flex;
  flex-direction: column;

  &:not(:first-child)::before {
    content: "";
    top: var(--sp-2);
    bottom: var(--sp-2);
    background: var(--shade3-15);
    width: 1px;
    position: absolute;
  }
`;

export default function MegaMenu({ className, menu: rowMenus }) {
  return (
    <MegaMenuWrapper className={className}>
      {rowMenus.map((columnMenus, key) => (
        <MenuColumnWrapper className="menu-category" key={key}>
          {columnMenus.map((menu, qKey) => (
            <SingleMenu menu={menu} key={qKey} />
          ))}
        </MenuColumnWrapper>
      ))}
    </MegaMenuWrapper>
  );
}
